import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { useBoundStore } from 'useStore';
import fetchForecastGeneralDetailData from '../services/fetchForecastGeneralDetailData';
import useCurrentMasterCountry from 'views/Components/Shared/hooks/useCurrentMasterCountry';
import useCountriesData from 'views/Components/Shared/Queries/countriesQuery';

export default function useForecastGeneralDetailData({ productId }) {
	const { accessToken } = useAuth();
	const countriesQuery = useCountriesData();
	const currentMasterCountry = useCurrentMasterCountry();
	const countryId = currentMasterCountry?.id;

	const selectedYear = useBoundStore((state) => state.fgSelectedYear);
	const selectedMarketplace = useBoundStore(
		(state) => state.fgSelectedMarketplace
	);

	const forecastGeneralDetailQuery = useQuery({
		queryKey: [
			'forecastGeneralDetail',
			{
				countryId,
				year: selectedYear,
				productId,
				marketplaceId: selectedMarketplace,
			},
		],
		queryFn: () =>
			fetchForecastGeneralDetailData({
				accessToken,
				countryId,
				year: selectedYear,
				productId,
				marketplaceId: selectedMarketplace,
			}),

		staleTime: Infinity,
		retry: false,
		enabled: !!countryId && !!selectedYear,
	});

	if (countriesQuery.isError) {
		throw countriesQuery.error;
	}

	return forecastGeneralDetailQuery;
}
